import router from './router'

import {
    loadToken,
} from '@/utils/cache'
const whiteList = ['login', 'redirect', 'pay_suc','qrcode-pay','face-indentify','sso','commsso','banknum-checkin-index','banknum-checkin-checkin']

router.beforeEach((to, from, next) => {
    let flag = whiteList.includes(to.name)
    if (flag || loadToken()) {
        next()
    } else {
        router.push({
            name: 'login'
        })
    }
    // next()
})



